import { render } from "./ShareholderNonAusCorporate.vue?vue&type=template&id=291ee848&scoped=true&ts=true"
import script from "./ShareholderNonAusCorporate.vue?vue&type=script&lang=ts"
export * from "./ShareholderNonAusCorporate.vue?vue&type=script&lang=ts"

import "./ShareholderNonAusCorporate.vue?vue&type=style&index=0&id=291ee848&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-291ee848"]])

export default __exports__